import { useNavigate } from 'react-router-dom';
import closeIcon from '../../assets/icons/close-icon.svg';
import ZahtjeviService from '../../service/ZahtjeviService';
import { useEffect, useRef } from 'react';
import { useAppDispatch } from '../../store/hooks/hooks';
import { toggleUpdateDocumentsTable } from '../../store/slice/ZahtjeviSlice';

interface Props {
  documentIds: Array<string>;
  deleteSource: number;
  setModalDelete: (modalOn: boolean) => void;
  toastMessage: ((message: string) => void) | undefined;
}

const DeleteDocument = ({ documentIds, deleteSource, setModalDelete, toastMessage }: Props) => {
  console.log(documentIds);
  const navigate = useNavigate();
  const modalRef = useRef<HTMLDivElement>(null);

  const dispatch = useAppDispatch();

  const handleDelete = () => {
    ZahtjeviService.removeMultipleDocuments(documentIds).then(() => {
      dispatch(toggleUpdateDocumentsTable());
      console.log(toastMessage);
      toastMessage && toastMessage('Document deleted');
      setModalDelete(false);
      deleteSource === 2 && navigate('/', { state: { delete: true } });
    });
  };

  useEffect(() => {
    const handleMouseDown = (event: MouseEvent) => {
      if (!modalRef.current?.contains(event.target as Node)) {
        setModalDelete(false);
      }
    };
    window.addEventListener('mousedown', handleMouseDown);

    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setModalDelete(false);
      }
    };
    window.addEventListener('keydown', handleEsc);

    return () => {
      window.removeEventListener('keydown', handleEsc);
      window.removeEventListener('mousedown', handleMouseDown);
    };
  }, []);

  return (
    <div className='dark-100 modal-active'>
      <div className='main-modal color-base-100'>
        <div className='padding-bottom-5' ref={modalRef}>
          <form className='form modal-form relative'>
            <h3 className='font-h3-regular'>Delete Document</h3>
            <img className='modal-form__close' src={closeIcon} alt='close-icon' onClick={() => setModalDelete(false)} />

            <p className='font-h4-regular'>Are you sure you want to delete this document?</p>

            <div className='text-right margin-top-3'>
              <span className='button-tertionary font-h5-medium' onClick={() => setModalDelete(false)}>
                Cancel
              </span>
              <span onClick={handleDelete} className='button-primary margin-left-2'>
                Delete
              </span>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default DeleteDocument;
